import React from "react";
import { useSelector } from "react-redux";
import AgencyServices from "./agency";
import FreelancerServices from "./freelancer";

function ServicesPage() {
  const user = useSelector((state) => state.user || {});
  const isAgency = user?.isAgency ?? false;

  return (
    <>
      {isAgency ? (
        <AgencyServices lockService={user?.lockService} />
      ) : (
        <FreelancerServices lockService={user?.lockService} />
      )}
    </>
  );
}

export default ServicesPage;
